/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const next = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M6.6 6L5.4 7l4.5 5-4.5 5 1.1 1 5.5-6-5.4-6zm6 0l-1.1 1 4.5 5-4.5 5 1.1 1 5.5-6-5.5-6z" />
	</SVG>
);

export default next;
